import React from "react";
// UI Framework
import { TableCell, TableRow } from "@mui/material";
import { toast } from "react-toastify";
// Common Components
import {
  Form,
  TextInput,
  Button,
  DynamicDropdown,
  Table,
} from "src/Components";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";
// Requests
import {
  setServerRiskFreeRate,
  upsertGreekSymbolConstraint,
  getGreekSymbolConstraint,
  getBourseKalaInstrument,
} from "src/Requests/iMEMarketWatch";
// Types
import type {
  IVSetting,
  GreekSymbolConstraint,
} from "src/Interfaces/iMEMarketWatch";

const IVModal: React.FC = () => {
  //local states
  const [loading, setLoading] = React.useState(false);
  const [riskFreeRate, setRiskFreeRate] = React.useState();
  const [formValues, setFormValues] = React.useState<IVSetting>(
    {} as IVSetting,
  );
  const [greekSymbolConstraints, setgreekSymbolConstraints] = React.useState<
    GreekSymbolConstraint[]
  >([] as GreekSymbolConstraint[]);

  React.useEffect(() => {
    getGreekSymbolConstraint()
      .then((resp) => {
        setRiskFreeRate(resp.riskFreeRate.toString() || "");
        setgreekSymbolConstraints(resp.greekSymbolConstraints);
      })
      .catch(packetErrorHandler);
  }, []);

  const changeHandler = (name: string, value: any) => {
    setFormValues({ ...formValues, [name]: value });
  };

  const setRiskFreeRateHandler = () => {
    setServerRiskFreeRate(Number(riskFreeRate))
      .then((resp) => {
        if (resp.data) toast.success(resp.msg);
        else toast.error(resp.msg);
      })
      .catch(packetErrorHandler);
  };

  const clickHandler = () => {
    setLoading(true);
    upsertGreekSymbolConstraint(formValues)
      .then((resp) => {
        toast.success(resp.msg);
        setFormValues({} as IVSetting);
        getGreekSymbolConstraint()
          .then((resp) => {
            setRiskFreeRate(resp.riskFreeRate.toString() || "");
            setgreekSymbolConstraints(resp.greekSymbolConstraints);
          })
          .catch(packetErrorHandler);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const Header = (
    <>
      <TableCell>#</TableCell>
      <TableCell>نماد</TableCell>
      <TableCell>نوسان‌پذیری</TableCell>
      <TableCell>سود نقدی</TableCell>
    </>
  );

  const Body = (
    <>
      {greekSymbolConstraints?.map((item, i) => (
        <TableRow>
          <TableCell>{i + 1}</TableCell>
          <TableCell>{item.baseAssetName}</TableCell>
          <TableCell>{item.volatilityBaseIns}</TableCell>
          <TableCell>{item.dividendYield}</TableCell>
        </TableRow>
      ))}
    </>
  );

  return (
    <div className="flex flex-row justify-start items-start gap-10">
      <Form className="p-3 gap-3 !w-60">
        <div className="flex flex-row justify-start items-end gap-5">
          <TextInput
            label="نرخ بهره"
            name=""
            onChange={(_, v) => setRiskFreeRate(v)}
            value={riskFreeRate}
            extraLabel
            kind="negativeDecimalNumbers"
          />
          <Button
            text="اعمال"
            variant="contained"
            onClick={setRiskFreeRateHandler}
            className="!h-8 !w-8"
          />
        </div>
        <DynamicDropdown
          dropdown={{
            name: "baseAssetId",
            placeholder: "نماد پایه",
            extraLabel: true,
          }}
          onChange={changeHandler}
          getData={getBourseKalaInstrument}
          value={formValues.baseAssetId}
        />

        <TextInput
          label="نوسان پذیری"
          value={formValues.volatilityBaseIns?.toString()}
          name="volatilityBaseIns"
          onChange={changeHandler}
          kind="negativeDecimalNumbers"
          extraLabel
        />
        <TextInput
          label="سود نقدی"
          value={formValues.dividendYield?.toString()}
          name="dividendYield"
          onChange={changeHandler}
          kind="negativeDecimalNumbers"
          extraLabel
        />

        <Button
          onClick={clickHandler}
          text="ثبت"
          variant="contained"
          //   disabled={checkDisabled()}
          loading={loading}
        />
      </Form>
      <div
        className={`max-w-full mx-auto flex flex-row justify-center items-start gap-3 max-h-[500px] overflow-y-auto`}
      >
        <Table header={Header} body={Body} />
      </div>
    </div>
  );
};

export default IVModal;
